import React, {
	useContext,
	useState,
	useEffect,
} from "react";
import {
	levels,
	log,
} from "../utils/Logger.js";
import { slice } from 'lodash';

import { useMissedTapsHistory } from 'components/data/transit-account/RidesHistory.query.js';
import {
	getMissedTapsTrips,
	getAutoFilledTapsTrips,
} from 'utils/TripHistory.js';


const defaultMethod = () => log(null, levels.error, "TapsAlertsContext was used before it was ready");

export const TapsAlertsContext = React.createContext({
	isLoading: true,
	alerts: [],
	addAlerts: defaultMethod,
	removeAlert: defaultMethod,
});

export const useTapsAlertsContext = () => useContext(TapsAlertsContext);

const TapsAlertsProvider = ({ children }) => {
	const [ tapsAlerts, setAlerts ] = useState([]);
	const { lineItems, loading } = useMissedTapsHistory();

	// // runs when we get new alert data
	useEffect(() => {
		if (!loading && lineItems?.length > 0) {

			const autoFilledTapsTrips = getAutoFilledTapsTrips({ lineItems }) ?? [];
			const missedTapsTrips = getMissedTapsTrips({ lineItems }) ?? [];
			const missedTaps = [ ...autoFilledTapsTrips, ...missedTapsTrips ];

			setAlerts(missedTaps);
		}
	}, [
		loading,
		lineItems,
		setAlerts,
	]);

	const addAlert = (alert) => setAlerts(tapsAlerts.concat(alert));

	const removeAlert = (event) => {
		event && event.preventDefault();
		setAlerts(slice(tapsAlerts, 1));
	};

	const contextValue = {
		tapsAlerts,
		addAlert,
		removeAlert,
	};

	return (
		<TapsAlertsContext.Provider value={contextValue}>
			{children}
		</TapsAlertsContext.Provider>
	);
};

export default TapsAlertsProvider;
